
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basecamplejeune",
      function () {
        return require("private-next-pages/basecamplejeune/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basecamplejeune"])
      });
    }
  